import React, { useCallback, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import StripeConnectSection from '../../../components/StripeConnect/StripeConnectSection'
import { ROUTES } from '../../../constants/routes'
import useApi from '../../../hooks/useApi'
import {
  getStripeAccountStatus,
  isCharityStripeComplete,
  STRIPE_ACCOUNT_STATUS_VARIANTS,
} from '../../../lib/stripeConnect'
import CharityVerificationRequirementsModal from './CharityVerificationRequirementsModal'

export default function CharityStripeConnectSection({ charityId }) {
  const [showRequirementsModal, setShowRequirementsModal] = useState(false)
  const [continuing, setContinuing] = useState(false)
  const pendingConnectRef = useRef(null)

  const {
    createCharityStripeAccount,
    getCharityStripeAccountStatus,
    getCharityStripeOnboardingLink,
  } = useApi()

  const returnUrl = `${window.location.origin}${ROUTES.CHARITY_DASHBOARD}?stripe_return=true&charity_id=${charityId}`
  const refreshUrl = `${window.location.origin}${ROUTES.CHARITY_DASHBOARD}?stripe_refresh=true&charity_id=${charityId}`

  const handleConnectClick = useCallback(connect => {
    pendingConnectRef.current = connect
    setShowRequirementsModal(true)
  }, [])

  const handleRequirementsContinue = useCallback(async () => {
    setShowRequirementsModal(false)
    setContinuing(true)
    try {
      await pendingConnectRef.current?.()
    } finally {
      setContinuing(false)
    }
  }, [])

  if (!charityId) {
    return null
  }

  return (
    <>
      <StripeConnectSection
        createStripeAccount={createCharityStripeAccount}
        entityId={charityId}
        getAccountStatus={getCharityStripeAccountStatus}
        getBadgeStatusKey={getStripeAccountStatus}
        getOnboardingLink={getCharityStripeOnboardingLink}
        isComplete={isCharityStripeComplete}
        onConnectClick={handleConnectClick}
        refreshUrl={refreshUrl}
        returnUrl={returnUrl}
        statusVariants={STRIPE_ACCOUNT_STATUS_VARIANTS}
        translationPrefix="charities.dashboard.stripe"
      />
      <CharityVerificationRequirementsModal
        show={showRequirementsModal}
        onHide={() => setShowRequirementsModal(false)}
        onContinue={handleRequirementsContinue}
        continuing={continuing}
      />
    </>
  )
}

CharityStripeConnectSection.propTypes = {
  charityId: PropTypes.number.isRequired,
}
